module.exports = __webpack_public_path__ + "static/video-audio-image-documents-2e6de1ce1e70136574ebbf693fcbbf4a.svg";